import * as Types from '../../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateIvrMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  e164?: Types.InputMaybe<Types.Scalars['String']['input']>;
  identifier: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type CreateIvrMutation = { __typename?: 'Mutation', createIvr?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', context?: string | null, location: Array<string>, type: string }> | null } | null };


export const CreateIvrDocument = gql`
    mutation CreateIvr($domainId: Int!, $e164: String, $identifier: String!, $name: String!) {
  createIvr(
    domainId: $domainId
    e164: $e164
    identifier: $identifier
    name: $name
  ) {
    id
    errors {
      context
      location
      type
    }
  }
}
    `;
export type CreateIvrMutationFn = Apollo.MutationFunction<CreateIvrMutation, CreateIvrMutationVariables>;

/**
 * __useCreateIvrMutation__
 *
 * To run a mutation, you first call `useCreateIvrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIvrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIvrMutation, { data, loading, error }] = useCreateIvrMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      e164: // value for 'e164'
 *      identifier: // value for 'identifier'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateIvrMutation(baseOptions?: Apollo.MutationHookOptions<CreateIvrMutation, CreateIvrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIvrMutation, CreateIvrMutationVariables>(CreateIvrDocument, options);
      }
export type CreateIvrMutationHookResult = ReturnType<typeof useCreateIvrMutation>;
export type CreateIvrMutationResult = Apollo.MutationResult<CreateIvrMutation>;
export type CreateIvrMutationOptions = Apollo.BaseMutationOptions<CreateIvrMutation, CreateIvrMutationVariables>;